<div class="se-fab-slider">
    <div class="se-fab-slider-buttons" *ngIf="buttonsVisible">
        <button mat-button (click)="onDecrease()" [disabled]="canDecrease()">
            <mat-icon>{{ decreaseIcon }}</mat-icon>
        </button>
        <button mat-button (click)="onIncrease()" [disabled]="canIncrease()">
            <mat-icon>{{ increaseIcon }}</mat-icon>
        </button>
    </div>
    <mat-slider
        class="se-mat-slider"
        [min]="min"
        [max]="max"
        [step]="step"
        [discrete]="showLabel"
        [displayWith]="formatLabel"
        #ngSlider
    >
        <input matSliderThumb [(ngModel)]="value" (ngModelChange)="onInputChange($event)" #slider />
    </mat-slider>
</div>
